export default __webpack_public_path__ + "static/media/J270MANB2.b5c78f09.pdf";